var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-body"},[_c('div',{staticClass:"app-body__content"},[_vm._t("default")],2),(_vm.submitting)?_c('div',{staticClass:"app-body__submitting"},[_c('b-loading',{attrs:{"active":"","is-full-page":false}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }